<template>
  <b-spinner v-show="show" class="blumar-loading" variant="primary" type="grow" label="Spinning"></b-spinner>
</template>

<script>
export default {
  computed: {
    show() {
      return this.$store.getters.loadingValue;
    }
  }
};
</script>

<style scoped>
.blumar-loading {
  position: fixed;
  left: 48.2%;
  z-index: 9999;
  bottom: 15px;
  width: 3rem;
  height: 3rem;
  color: #163247 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/BlumarLoading.vue